<div class="filters-wrapper" [class.disabled]="isLoading">
  <div class="daterange-pickers-wrapper">
    <app-dropdown-select
      data-at-power-limitation-history-filter-kind
      [options]="filters"
      [defaultValue]="defaultFilter"
      (valueSelected)="changeFilter($event)"
    ></app-dropdown-select>

    <div
      *ngIf="gatewayProperties$ | async as properties"
      data-at-power-limitation-history-datepickers-wrapper
      class="filter-options-wrapper"
    >
      <ng-container [ngSwitch]="activeFilter">
        <app-day-datepicker
          *ngSwitchCase="FilterType.Day"
          gtm="onSelect"
          gtmAction="Select Day"
          gtmCategory="powerLimitationHistory"
          [minDate]="properties.registeredAt"
          (dateChanged)="changeDate($event)"
        >
        </app-day-datepicker>

        <app-month-datepicker
          *ngSwitchCase="FilterType.Month"
          gtm="onSelect"
          gtmAction="Select Month"
          gtmCategory="powerLimitationHistory"
          [minDate]="properties.registeredAt"
          (dateChanged)="changeDate($event)"
        >
        </app-month-datepicker>

        <app-year-datepicker
          *ngSwitchCase="FilterType.Year"
          gtm="onSelect"
          gtmAction="Select Year"
          gtmCategory="powerLimitationHistory"
          [minDate]="properties.registeredAt"
          (dateChanged)="changeDate($event)"
        >
        </app-year-datepicker>
      </ng-container>
    </div>
  </div>
</div>

<div class="mb-4">
  <app-chip-filters *ngIf="powerLimitationAmount">
    <app-chip-filter
      data-at-filter="all"
      gtm="onSetFilter"
      gtmAction="All power limitation history list"
      gtmCategory="powerLimitationHistory"
      [active]="controlCommandFilterType === powerLimitationControlCommandType.All"
      [count]="powerLimitationAmount"
      (click)="filterByPowerLimitationControlCommandType(powerLimitationControlCommandType.All)"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.ALL' | translate }}
    </app-chip-filter>
    <app-chip-filter
      data-at-filter="consumptionLimitation"
      *ngIf="consumptionLimitationAmount"
      gtm="onSetFilter"
      gtmAction="Consumption limitation"
      gtmCategory="powerLimitationHistory"
      [active]="
        controlCommandFilterType === powerLimitationControlCommandType.ConsumptionLimitation
      "
      [count]="consumptionLimitationAmount"
      (click)="
        filterByPowerLimitationControlCommandType(
          powerLimitationControlCommandType.ConsumptionLimitation
        )
      "
    >
      {{
        '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.CONSUMPTION_LIMITATION'
          | translate
      }}
    </app-chip-filter>
    <app-chip-filter
      data-at-filter="productionLimitationAmount"
      *ngIf="productionLimitationAmount"
      gtm="onSetFilter"
      gtmAction="Feed in limitation"
      gtmCategory="powerLimitationHistory"
      [active]="controlCommandFilterType === powerLimitationControlCommandType.ProductionLimitation"
      [count]="productionLimitationAmount"
      (click)="
        filterByPowerLimitationControlCommandType(
          powerLimitationControlCommandType.ProductionLimitation
        )
      "
    >
      {{
        '+INSTALLATIONS.INSTALLATIONS.POWER_LIMITATION_HISTORY_LOG.FEED_IN_LIMITATION' | translate
      }}
    </app-chip-filter>
  </app-chip-filters>
</div>
